module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-nav-item",
    class: _vm.rootClasses
  }, [_c('a', {
    staticClass: "u-reset sub-nav-item--link",
    class: _vm.btnClasses,
    attrs: {
      "href": _vm.child.path
    },
    on: {
      "click": function($event) {
        _vm.onMenuItemClick($event)
      }
    }
  }, [_c('span', {
    staticClass: "sub-nav-item--text",
    domProps: {
      "innerHTML": _vm._s(_vm.child.label)
    }
  })])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5326342", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5326342","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/sub-nav-item/index.vue
// module id = 577
// module chunks = 7